import React from "react";
import LoginAndRegister from "../Auth/LoginAndRegister";
const RegisterPage = () => {
  return <LoginAndRegister loginOrRegister={"register"} />;
};

export default RegisterPage;
